import React from 'react';
import { useObservable } from 'react-use-observable';

import { SummaryBar } from 'v2/components/Pages/Reports/SummaryBar';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import { refundsService } from 'v2/services/reports/refunds';

import { ExportRefunds } from './Export';

export const Details = () => {
  const [totalItems] = useObservable(() => refundsService.getTotalItems(), []);
  const [totalRefunded] = useObservable(() => refundsService.getTotalRefunded(), []);
  const [isLoading] = useObservable(() => refundsService.isLoading(), []);

  const refundsCount = `${totalItems} ${totalItems > 1 ? 'reembolsos' : 'reembolso'}`;

  if (isLoading) return null;

  return (
    <SummaryBar
      countLabel={refundsCount}
      totalLabel='Total Reembolsado'
      totalValue={totalRefunded || 0}
      exportSlot={
        <PermissionHide action='myeduzz:reports:exportar'>
          <ExportRefunds />
        </PermissionHide>
      }
    />
  );
};
